import { render, staticRenderFns } from "./InsuranceMaintenanceForm.vue?vue&type=template&id=5e4c4e18&scoped=true&"
import script from "./InsuranceMaintenanceForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceMaintenanceForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceMaintenanceForm.vue?vue&type=style&index=0&id=5e4c4e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c4e18",
  null
  
)

export default component.exports